import type { DeepReadonly } from 'vue'
import type { Slide, ThreeDSlide } from '@/entities/deck'

export const isThreeDSlide = (slide: DeepReadonly<Slide> | Slide | undefined | null): slide is DeepReadonly<ThreeDSlide> =>
  slide?.type === 'M'
